import React from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import PriceBadge from '@/components/ui/PriceBadge';
import { TRENDING } from '@/data/marketData';
import { Users } from 'lucide-react';

interface TrendingSectionProps {
  lang: 'en' | 'ta';
}

export default function TrendingSection({ lang }: TrendingSectionProps) {
  return (
    <section className="pb-4">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <span className="text-xl">🔥</span>
          <h2 className="text-lg font-bold text-foreground">
            {lang === 'en' ? 'Trending Today' : 'இன்று பிரபலமானவை'}
          </h2>
        </div>
        <Link href="/product-category-browse" className="text-sm text-primary font-semibold hover:underline">
          {lang === 'en' ? 'View all →' : 'அனைத்தும் →'}
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {TRENDING.map(product => (
          <Link key={`trending-${product.id}`} href={`/product-detail?id=${product.id}`} className="block group">
            <div className="card-base card-hover overflow-hidden">
              <div className="relative aspect-square overflow-hidden bg-muted">
                <AppImage
                  src={product.image}
                  alt={product.imageAlt}
                  fill
                  sizes="(max-width: 768px) 50vw, 16vw"
                  className="object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-3">
                <p className="font-semibold text-xs text-foreground truncate">
                  {lang === 'en' ? product.name : product.nameTa}
                </p>
                <div className="flex items-center justify-between mt-1.5">
                  <span className="price-value text-sm">₹{product.currentPrice}</span>
                  <PriceBadge trend={product.trend} change={product.priceChange} changePct={product.priceChangePct} />
                </div>
                <div className="flex items-center gap-1 mt-1.5">
                  <Users size={10} className="text-muted-foreground" />
                  <span className="text-xs text-muted-foreground font-tabular">
                    {product.watchlistCount.toLocaleString('en-IN')}
                  </span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}